module.exports = __webpack_public_path__ + "static/media/item_6_34_comp.4faf021e.png";